import Api from '../../services';

export const getPublicListings = (params) => {
  return (dispatch) => {
    return Api.listings.getPublicListings(params)
      .then((response) => {
        dispatch({
          type: 'GET_PUBLIC_LISTINGS',
          data: response,
        });
        return response;
      });
  };
};

export const getListingDetails = (id, params) => {
  return (dispatch) => {
    return Api.listings.getListingDetails(id, params)
      .then((response) => {
        dispatch({
          type: 'GET_PUBLIC_LISTING_DETAILS',
          data: response,
        });
        return response;
      });
  };
};

export const getListingAvailability = (listingId, entityId, date) => {
  return (dispatch) => {
    return Api.listings.getListingAvailability(listingId, entityId, date).then((response) => {
      dispatch({
        type: 'GET_LISTING_AVAILABILITY',
        data: response,
      });
      return response;
    });
  };
};

export const estimateBookingCalculations = (listingId, data) => {
  return (dispatch) => {
    return Api.listings.estimateBookingCalculations(listingId, data).then((response) => {
      dispatch({
        type: 'ESTIMATE_BOOKING_CALCULATIONS',
        data: response,
      });
      return response;
    });
  };
};

export const getListingReviews = (listingId, params) => {
  return (dispatch) => {
    return Api.listings.getListingReviews(listingId, params).then((response) => {
      dispatch({
        type: 'GET_LISTING_REVIEWS',
        data: response,
      });
      return response;
    });
  };
};
